import { LocationIcon, CalendarIcon, ClockIcon } from "../icons";

const EventCardDetail = ({ item, dark = false }) => {
  return (
    <div className="flex items-center gap-2">
      {Object.entries(item).map(([key, value]) => (
        <div key={key} className="flex items-center gap-3">
          {key === "location" && <LocationIcon color={dark ? "white" : "black"} />}
          {key === "timeFrame" && <CalendarIcon color={dark ? "white" : "black"} />}
          {key === "eventTime" && <ClockIcon color={dark ? "white" : "black"} />}
          <p className="uppercase">{String(value)}</p>
        </div>
      ))}
    </div>
  );
};

export default EventCardDetail;
